import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/detect/ADetectVideoSuggest/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/detect/ADetectVideoSuggest/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.post("/detect/ADetectVideoSuggest/edit", {id:params})
}
function SUBMIT_ADD(params) {
    return  axios.post("/detect/ADetectVideoSuggest/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/detect/ADetectVideoSuggest/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/detect/ADetectVideoSuggest/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/detect/ADetectVideoSuggest/delete",{
        params: {
            ids:params
        }
    } )
}

export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
}